import React from "react";
import "./articleCard.css";

export default function ArticleCard({ link, img, imgAlt, title, quote }) {
  return (
    <a
      className="article-card"
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={`Artikel av ${title} med citatet: ${quote}`}
    >
      <article aria-hidden="true">
        <img src={img} alt={imgAlt} height={480} width={400}/>
        <h3>{title}</h3>
        <p>"{quote}"</p>
      </article>
    </a>
  );
}
